// extracted by mini-css-extract-plugin
module.exports = {"orders":"feed-list_orders__3qQZ4 ml-5 mr-5 pr-2","orders__profile":"feed-list_orders__profile__RiHiZ feed-list_orders__3qQZ4 ml-5 mr-5 pr-2"};